<template>
  <div class="my-order">
    <div class="title-wrap">
      <div class="img" @click="$router.push('/main')">
        <img src="../assets/images/left.png" alt />
      </div>
      <span>我的订单</span>
    </div>
    <!-- tab -->
    <div class="order-tabs">
      <van-tabs
        title-active-color="#ff9900"
        color="#ff9900"
        :animated="true"
        :sticky="true"
        @click="onClick"
        v-model="active"
      >
        <van-tab title="全部">
          <van-pull-refresh v-model="allListPage.isRefresh" @refresh="onRefresh('allList')">
            <van-list
              v-model="allListPage.isLoading"
              :finished="allListPage.finished"
              finished-text="没有更多了"
              @load="onLoad('allList')"
              :immediate-check="false"
            >
              <div class="order-content">
                <OrderList :orderList="allList" v-if="allListFlag" @cancel="cancel"/>
                <NoProduct :img="imgsrc" text="您还没有相关订单哦~" :btnFlag="true" v-if="!allListFlag" />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待支付">
          <van-pull-refresh v-model="waitListPage.isRefresh" @refresh="onRefresh('waitPaid')">
            <van-list
              v-model="waitListPage.isLoading"
              :finished="waitListPage.finished"
              finished-text="没有更多了"
              @load="onLoad('waitPaid')"
              :immediate-check="false"
            >
              <div class="order-content">
                <OrderList :orderList="waitPaid" v-if="waitPaidFlag" @cancel="cancel"/>
                <NoProduct :img="imgsrc" text="您还没有相关订单哦~" :btnFlag="true" v-if="!waitPaidFlag" />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待发货">
          <van-pull-refresh v-model="shipListPage.isRefresh" @refresh="onRefresh('waitShip')">
            <van-list
              v-model="shipListPage.isLoading"
              :finished="shipListPage.finished"
              finished-text="没有更多了"
              @load="onLoad('waitShip')"
              :immediate-check="false"
            >
              <div class="order-content">
                <OrderList :orderList="waitShip" v-if="waitShipFlag" />
                <NoProduct :img="imgsrc" text="您还没有相关订单哦~" :btnFlag="true" v-if="!waitShipFlag" />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待收货">
          <van-pull-refresh v-model="receiptListPage.isRefresh" @refresh="onRefresh('waitReceipt')">
            <van-list
              v-model="receiptListPage.isLoading"
              :finished="receiptListPage.finished"
              finished-text="没有更多了"
              @load="onLoad('waitReceipt')"
              :immediate-check="false"
            >
              <div class="order-content">
                <OrderList :orderList="waitReceipt" v-if="waitReceiptFlag" @receipt="receipt" />
                <NoProduct :img="imgsrc" text="您还没有相关订单哦~" :btnFlag="true" v-if="!waitReceiptFlag" />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="待自提">
          <van-pull-refresh v-model="liftingListPage.isRefresh" @refresh="onRefresh('waitLifting')">
            <van-list
              v-model="liftingListPage.isLoading"
              :finished="liftingListPage.finished"
              finished-text="没有更多了"
              @load="onLoad('waitLifting')"
              :immediate-check="false"
            >
              <div class="order-content">
                <OrderList :orderList="waitLifting" v-if="waitLiftingFlag" @lifting="Lifting"/>
                <NoProduct :img="imgsrc" text="您还没有相关订单哦~" :btnFlag="true" v-if="!waitLiftingFlag" />
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import OrderList from "../components/OrderList";
import NoProduct from "../components/NoProduct";
import {
  SaleAllOrder,
  SaleWaitOrder,
  SaleWaitshipOrder,
  SaleWaitreceiptOrder,
  SaleWaitliftingOrder,
  SaleSuccessOrder,
  SaleCancelOrder,
  Receipt,
  Lifting,
  CancelOrder
} from "../request/api";
export default {
  name: "my-order",
  data() {
    return {
      active: 0,
      allList: {}, //全部订单
      waitPaid: {}, //待支付订单
      waitShip: {}, //待发货订单
      waitReceipt: {}, //待收货
      waitLifting: {}, //待自提
      allListFlag: false,
      waitPaidFlag: false,
      waitShipFlag: false,
      waitReceiptFlag: false,
      waitLiftingFlag: false,
      size: 10,
      allListPage: {
        pageNum: 1,
        isLoading: false,
        finished: false,
        isRefresh: false
      },
      waitListPage: {
        pageNum: 1,
        isLoading: false,
        finished: false,
        isRefresh: false
      },
      shipListPage: {
        pageNum: 1,
        isLoading: false,
        finished: false,
        isRefresh: false
      },
      receiptListPage: {
        pageNum: 1,
        isLoading: false,
        finished: false,
        isRefresh: false
      },
      liftingListPage: {
        pageNum: 1,
        isLoading: false,
        finished: false,
        isRefresh: false
      },
      imgsrc: require("../assets/images/order/img_no_order@2x.png")
    };
  },
  components: {
    OrderList,
    NoProduct
  },
  created() {
    let index = this.$route.params.index;
    if (index) {
      this.active = index;
    }
    this.getOrderList(this.active);
  },
  methods: {
    //点击标签
    onClick(name, title) {
      this.getOrderList(name);
    },

    //确认收货
    receipt(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认收货"
        })
        .then(() => {
          Receipt(item).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "确认成功",
                duration: 700
              });
              this.orderRequest(
                SaleWaitreceiptOrder,
                "waitReceipt",
                "waitReceiptFlag"
              );
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //确认自提
    Lifting(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认自提"
        })
        .then(() => {
          Lifting(item).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "确认成功",
                duration: 700
              });
              this.orderRequest(
                SaleWaitliftingOrder,
                "waitLifting",
                "waitLiftingFlag"
              );
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    //取消订单
    cancel(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否取消订单"
        })
        .then(() => {
          CancelOrder(item).then(res => {
            if (res.status == 200) {
              this.$toast.success({
                message: "取消成功",
                duration: 700
              });
              this.orderRequest(SaleAllOrder, "allList", "allListFlag");
              this.orderRequest(SaleWaitOrder, "waitPaid", "waitPaidFlag");
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },

    //获取订单列表
    getOrderList(type) {
      switch (type) {
        case 0:
          //获取全部订单列表
          this.orderRequest(SaleAllOrder, "allList", "allListFlag");
          break;
        case 1:
          //获取待支付订单
          this.orderRequest(SaleWaitOrder, "waitPaid", "waitPaidFlag");
          break;
        case 2:
          //获取待发货订单
          this.orderRequest(SaleWaitshipOrder, "waitShip", "waitShipFlag");
          break;
        case 3:
          //获取待收货订单
          this.orderRequest(
            SaleWaitreceiptOrder,
            "waitReceipt",
            "waitReceiptFlag"
          );
          break;
        case 4:
          //获取待自提订单
          this.orderRequest(
            SaleWaitliftingOrder,
            "waitLifting",
            "waitLiftingFlag"
          );
          break;
      }
    },

    //获取多个订单列表
    orderRequest(fn, orderType, orderFlag) {
      fn({}).then(res => {
        this[orderType] = res.data;
        if (this[orderType].records.length > 0) {
          this[orderType].records.forEach(el => {
            this.$set(el, "rotate", false);
          });
          this[orderFlag] = true;
        }
      });
    },

    // 上拉加载更多
    onLoad(orderType) {
      switch (orderType) {
        case "allList":
          this.loadMore(SaleAllOrder, "allList", "allListPage");
          break;
        case "waitPaid":
          this.loadMore(SaleWaitOrder, "waitPaid", "waitListPage");
          break;
        case "waitShip":
          this.loadMore(SaleWaitshipOrder, "waitShip", "shipListPage");
          break;
        case "waitReceipt":
          this.loadMore(SaleWaitreceiptOrder, "waitReceipt", "receiptListPage");
          break;
        case "waitLifting":
          this.loadMore(SaleWaitliftingOrder, "waitLifting", "liftingListPage");
          break;
      }
    },

    // 多个上拉加载更多
    loadMore(fn, orderType, listPage) {
      setTimeout(() => {
        fn({
          pageNum: (this[listPage].pageNum += 1),
          pageSize: this.size
        }).then(res => {
          if (res.data.records.length > 0) {
            this[listPage].isLoading = false;
            res.data.records.forEach(el => {
              this.$set(el, "rotate", false);
            });
            this[orderType].records = this[orderType].records.concat(
              res.data.records
            );
          } else {
            this[listPage].isLoading = false;
            this[listPage].finished = true;
          }
        });
      }, 500);
    },

    //下拉刷新
    onRefresh(orderType) {
      switch (orderType) {
        case "allList":
          this.orderRefresh(
            "allListPage",
            SaleAllOrder,
            "allList",
            "allListFlag"
          );
          break;
        case "waitPaid":
          this.orderRefresh(
            "waitListPage",
            SaleWaitOrder,
            "waitPaid",
            "waitPaidFlag"
          );
          break;
        case "waitShip":
          this.orderRefresh(
            "shipListPage",
            SaleWaitshipOrder,
            "waitShip",
            "waitShipFlag"
          );
          break;
        case "waitReceipt":
          this.orderRefresh(
            "receiptListPage",
            SaleWaitreceiptOrder,
            "waitReceipt",
            "waitReceiptFlag"
          );
          break;
        case "waitLifting":
          this.orderRefresh(
            "liftingListPage",
            SaleWaitliftingOrder,
            "waitLifting",
            "waitLiftingFlag"
          );
          break;
      }
    },

    orderRefresh(listPage, fn, orderType, orderFlag) {
      setTimeout(() => {
        this.$toast("刷新成功");
        this[listPage].isRefresh = false;
        this.orderRequest(fn, orderType, orderFlag);
      }, 500);
    }
    // toOrderDetail(sno){
    //   console.log(sno)
    // }
  }
};
</script>

<style lang="less" scoped>
.title-wrap {
  background: #fff;
  text-align: center;
  color: #333;
  font-size: 34px;
  width: 100%;
  height: 90px;
  line-height: 90px;
  box-sizing: border-box;
  position: sticky;
  border-bottom: 1px solid #f2f2f2;
  top: 0;
  z-index: 99;
  .img {
    height: 43px;
    width: 43px;
    float: left;
    margin: 10px 0 0 30px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.my-order {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.order-tabs {
  margin-bottom: 20px;
}
</style>